import { render, staticRenderFns } from "./borrowPopup.vue?vue&type=template&id=b0bc0222&scoped=true&"
import script from "./borrowPopup.vue?vue&type=script&lang=js&"
export * from "./borrowPopup.vue?vue&type=script&lang=js&"
import style0 from "./borrowPopup.vue?vue&type=style&index=0&id=b0bc0222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0bc0222",
  null
  
)

export default component.exports